import React, { useState } from "react";
import styles from "../../styles/components/demandData.module.scss";
import Icons from "../../public/assets/svg";
import EditModal from "../demandEditModal/index";
import DemandFilters from "../demandFilters/index";
import MobileFilters from "../MobileFilters";
import DropDown from "../listWithoutcheck";
import axios from "axios";
import endpoint from "../../utility/endpoints";
import { useRouter } from "next/router";
import _get from "lodash/get";
import Loader from "../Loader";
import Fuse from "fuse.js";
import SuccessModal from "../../pages/successModal";
import Pagination from "../PaginationDemand";
import { useMediaQuery } from "react-responsive";
import { sessionTimeOutCheck, checkExpiry } from "../../redux/global/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";


function index(props) {
  //console.log("props --- demand data  ----", props);
  const [noImage, setNoImage] = useState(false);
  const [successModal, setSuccessModal] = React.useState(false);
  const [message, setMessage] = React.useState("Demand Updated Successfully!");
  const [loader, setloader] = useState(false);
  const [searchState, setSearchState] = React.useState("");
  const router = useRouter();
  const [authData, setAuthData] = useState(null);
  const [length, setLength] = useState(0);
  const [paginationNum, setPaginationNum] = useState(1);
  const [botCount, setBotCount] = useState(0);
  const [filterBotCount, setFilterBotCount] = useState(0);
  const [filterPaginationNum, setFilterPaginationNum] = useState(1);
  const [first, setFirst ] = useState(true)

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" });

  React.useEffect(() => {
    try {
      let auth = JSON.parse(localStorage.getItem("auth")).data;

      setAuthData(auth);
    } catch (e) {
      console.log(e)
    }
  }, []);
  const data = props.data.content;
  const demandFormData = props.demandFormData.content;
  //console.log(demandFormData, "demandFormData");
  const [renderForm, setRenderForm] = React.useState(false);
  //  const clusterData = props.globalData.cluster_main_component[0];
  //  const leadPlatformData = props.globalData.lead_platform_main_component[0];

  function camelize(str) {
    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      })
      .replace(/\s+/g, "");
  }

  const [loading, setLoading] = useState(false);

  let initialState = {};
  let dropDownsInitialStates = {};
  data.field_demand_table_filters.map((item) => {
    initialState[camelize(item.field_label)] = "";
    dropDownsInitialStates[camelize(item.field_label)] = false;
  });

  data.field_demand_table_filters.map((item) => {
    item.value = camelize(item.field_label);
  });

  const [state, setState] = useState(initialState);
  const [dropDownState, setDropdownState] = React.useState(
    dropDownsInitialStates
  );

  const handleDropDown = (item) => {
    setDropdownState({
      ...dropDownsInitialStates,
      [item]: !dropDownState[item],
    });
  };

  const gotDropDownValue = (value, dropdownParent) => {
    setDropdownState(dropDownsInitialStates);
    setState({ ...state, [dropdownParent]: value });
  };

  const [modalactive, setmodalactive] = useState(false);
  const [filterActive, setFilterActive] = useState(false);
  const [demandData, setDemandData] = useState([]);
  const [filteredDemandData, setFilteredDemandData] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [newDemand, setNewDemand] = useState(false);
  const [mobileFilterRelatedInfo, setMobileFilterRelatedInfo] = useState({});
  const [offset, setOffset] = useState(0);
  const [filterOffset, setFilterOffset] = useState(0);
  const [filterOn, setFilterOn] = useState(false);

  const editModal = (editIndex) => {
    //console.log("edit modal  ---  index", editIndex);
    //console.log("demand data ---", demandData);
    if (editIndex != -1) {
      setEditIndex(editIndex);
    } else {
      setNewDemand(true);
    }
    let modal = !modalactive;
    setmodalactive(true);
    if (modal === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  };

  const closeModal = async (value) => {
    //console.log("value  ----", value);
    if (value == undefined) {
      setmodalactive(false);
      setNewDemand(false);
      return;
    } else if (value == "create") {
      await getAllDemands();
      setmodalactive(false);
      setNewDemand(false);
      setMessage("Demand Created Sucessfully");      
      setSuccessModal(true);
      

      
    } else if (value == "update") {
      await getAllDemands();
      setmodalactive(false);
      setNewDemand(false);
      setMessage("Demand Updated SucessFully");
      setSuccessModal(true);
      
      
    }
  };

  const filterClick = () => {
    setFilterActive(true);
  };

  const getAllDemands = async () => {
    try {
      let auth = await JSON.parse(localStorage.getItem("auth")).data;
      setLoading(true);
      setloader(true);
      props.setLoading(true);
      let authCheck = await JSON.parse(localStorage.getItem("auth")).data;

      let expiryStatus = await props.checkExpiry(authCheck);
      if (expiryStatus) {
        
      
      axios({
        method: "get",
        url: `${endpoint.baseUrl}/demands/getDemand`,
        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
        params: { offset: offset },
      }).then((resp) => {
        props.setLoading(false);
        if (resp.data.code == 403) {
          localStorage.removeItem("auth");
          sessionStorage.clear();
          props.sessionTimeOutCheck(true)
          setLoading(false)
          setloader(false)
          props.setLoading(false)
          
        } else if (resp.data.code == 200) {
          setFirst(false)
          setloader(false);
          setBotCount(resp.data.data.count);
          resp.data.data.rows.map((item, index) => {
            item.sessionDate = convertToDDMMYYYY(
              item.sessionDate.split("T")[0]
            );
            return item;
          });
          //console.log(resp.data.data, "response demand api");
          setDemandData(resp.data.data.rows);

          setFilteredDemandData(resp.data.data.rows);
          if (resp.data.data.rows.length == 0) {
            setNoImage(true);
          }
          setLoading(false);
        }
        
      });
    }
    else {
      props.sessionTimeOutCheck(true)
      setLoading(false)
          setloader(false)
          props.setLoading(false)
    }
    } catch (e) {}
  };

  React.useEffect(() => {
    setLoading(true);
    getAllDemands();
    
  }, []);

  React.useEffect( async () => {
    
   await getAllDemands();
  }, [props.getUpdatedDemands]);

  React.useEffect(async () => {
    if (!first){
      await getAllDemands();
    }
    
  }, [offset]);

  React.useEffect(async () => {
    if (!first) {
      await getFilterDemands();
    }
    
  }, [filterOffset]);

  React.useEffect(() => {
    
    paginationNum >= 1 && setOffset((paginationNum - 1) * 5);
  }, [paginationNum]);

  React.useEffect(() => {
    
    //console.log(filterPaginationNum, "pagination", filterOffset);
    filterPaginationNum >= 1 && setFilterOffset((filterPaginationNum - 1) * 5);
  }, [filterPaginationNum]);

  const getDemandsExcel = async () => {
    try {
      let Filters = {};
      for (let i in state) {
        if (state[i].length > 0) {
          Filters[i] = state[i];
        }
      }

      let authCheck = JSON.parse(localStorage.getItem("auth")).data;
      let expiryStatus = await props.checkExpiry(authCheck);

      if (expiryStatus) {
        let auth = await JSON.parse(localStorage.getItem("auth")).data;
        axios({
          method: "get",
          url: `${endpoint.baseUrl}/demands/getDemandFile`,
          headers: {
            Authorization: `${auth.accessToken}|${auth.email}`,
          },
          params: Filters,
        }).then((resp) => {
          if (resp.data.code == 403) {
            localStorage.removeItem("auth");
            sessionStorage.clear();
            props.sessionTimeOutCheck(true);
            setLoading(false)
            setloader(false)
            props.setLoading(false)
          } else if (resp.data.code == 200) {
            //console.log(resp.data, "demandexcelresponse");
            window.open(resp.data.data);
          }
        });
      } else {
        props.sessionTimeOutCheck(true);
        setLoading(false)
          setloader(false)
          props.setLoading(false)
      }
    } catch (e) {}
  };

  React.useEffect(async () => {
    getFilterDemands();
  }, [state]);

  const getFilterDemands = async () => {
    try {
      let auth = await JSON.parse(localStorage.getItem("auth")).data;
      let Filters = {};
      for (let i in state) {
        if (state[i].length > 0) {
          Filters[i] = state[i];
        }
      }

      let authCheck = JSON.parse(localStorage.getItem("auth")).data;
      let expiryStatus = await props.checkExpiry(authCheck);

      if (expiryStatus) {
        let auth = await JSON.parse(localStorage.getItem("auth")).data;
        if (
          Filters &&
          Object.keys(Filters).length === 0 &&
          Filters.constructor === Object
        ) {
          // console.log("first", "first")
          // setFilteredDemandData(demandData);
          getAllDemands()
          setFilterOn(false)
         
        } else {
          //console.log("second", "first")
          setLoading(true);
          Filters.offset = filterOffset;
          setFilterOn(true);
          //console.log("Filtersss", Filters);
          await axios({
            method: "get",
            url: `${endpoint.baseUrl}/demands/getDemand`,
            params: Filters,
            headers: {
              Authorization: `${auth.accessToken}|${auth.email}`,
            },
          }).then((resp) => {
            setLoading(false);
            if (resp.data.code == 200) {
              //console.log("fliter data  ---", resp.data);

              setFilterBotCount(resp.data.data.count);
              resp.data.data.rows.map((item, index) => {
                item.sessionDate = convertToDDMMYYYY(
                  item.sessionDate.split("T")[0]
                );
                return item;
              });
              //  setDemandData(resp.data.data)
              setFilteredDemandData(resp.data.data.rows);
              if (resp.data.data.rows.length == 0) {
                setNoImage(true);
              }
            } else if (resp.data.code == 403) {
              localStorage.removeItem("auth");
              sessionStorage.clear();
              props.sessionTimeOutCheck(true);
              props.setLoading(false)
              setLoading(false)
              setloader(false)
            }
          });
        }
      } else {
        props.sessionTimeOutCheck(true);
        setLoading(false)
          setloader(false)
          props.setLoading(false)
      }
    } catch (e) {}
  };

  const searchInTable = (e) => {
    setSearchState(e.target.value);
    //console.log("StateDemandd", state);
    if (e.target.value.length >= 3) {
      let stateFilter = state;
      stateFilter.search = e.target.value;
      setState({
        ...stateFilter,
      });
      setFilterOffset(0);
      setPaginationNum(1);
    } else if (e.target.value.length == 0) {
      let stateFilter = state;
      delete stateFilter.search
      setState({
        ...stateFilter,
      });
    }
    // else {
    //   let stateFilter = state;
    //   if (Object.keys(stateFilter).includes('search')) {
    //     delete stateFilter.search;
    //   };
    //   console.log('State Filter', stateFilter);
    //   setState({
    //     ...stateFilter
    //   })
    //   setFilterOffset(0);
    //   setPaginationNum(1);

    // }
  };

  const convertToDDMMYYYY = (date, Z) => {
    //console.log(date, "this is what I'm getting", Z);
    let year = date.slice(0, 4);
    let month = date.slice(5, 7);
    let day = date.slice(8, 10);

    let newDate = day + "-" + month + "-" + year;
    return newDate;
  };

  let arrayToMap = _get(props, "data.content.field_table_labels", []).slice(
    0,
    _get(props, "data.content.field_table_labels", []).length - 1
  );

  return (
    <div className={`${styles.demandDataWrapper} container`}>
      <div className={styles.demandActionHead}>
        <div className={styles.top}>
          <div className={styles.left}>
            <div className={styles.search}>
              <Icons name="searchGrayIcon" className={styles.searchIcon} />
              <input
                type="text"
                placeholder={_get(
                  props,
                  "data.content.field_search_placeholder",
                  ""
                )}
                onChange={searchInTable}
                value={searchState != "" ? searchState : ""}
              />
            </div>
          </div>
          <div className={styles.right}>
            <div className={styles.combinedBtn}>
              <span className={styles.rowBtn} onClick={() => editModal(-1)}>
                <Icons name="plusIcon" className={styles.plusIcon}></Icons>
                {_get(data, "field_options[0]", "")}
              </span>
              <span
                className={styles.rowBtn2}
                onClick={() => {
                  setState({ ...initialState });
                  setSearchState("");
                  setFilterOn(false);
                  setPaginationNum(1);
                }}
              >
                {_get(props, "fieldOptions[2]", "")}
              </span>
              <span className={styles.exportListBtn} onClick={getDemandsExcel}>
                <Icons name="uploadicon" className={styles.uploadIcon}></Icons>
                {_get(data, "field_options[1]", "")}
              </span>
            </div>
          </div>
        </div>
        <div className={styles.bottom}>
          {data.field_demand_table_filters.map((item, index) => (
            <div className={styles.inputGroup} key={index}>
              <label>
                <span> {item.field_form_field_title}</span>
              </label>
              <p
                className={`${styles.input}`}
                onClick={() => {
                  handleDropDown(camelize(item.field_label));
                }}
              >
                <span className={styles.left}>
                  {state[camelize(item.field_label)] == ""
                    ? item.field_input
                    : state[camelize(item.field_label)]}
                </span>
                <span className={styles.right}>
                  <Icons name="chevron" className={styles.chevron} />
                </span>
              </p>
              {dropDownState[item.value] == true ? (
                <div className={styles.dropi}>
                  <DropDown
                    dropdownParent={[item.value]}
                    values={item.field_options}
                    getDropdownValue={gotDropDownValue}
                    params="demandFilters"
                    closeAllDropdowns={() =>
                      setDropdownState(dropDownsInitialStates)
                    }
                  />
                </div>
              ) : null}
            </div>
          ))}
        </div>
      </div>
      <div className={styles.demandDataBody}>
        {/* {loader ? <Loader /> : */}
        <div className={styles.scrollableTable}>
          {filteredDemandData.length != 0 ? (
            <table>
              <thead>
                <tr>
                  {arrayToMap.map((item, index) => (
                    <th>
                      <div>{item}</div>
                    </th>
                  ))}
                  {/* <th><div>{_get(props, "data.content.field_table_labels[0]", "")}</div></th>
                  <th><div>{_get(props, "data.content.field_table_labels[1]", "")}</div></th>
                  <th><div>{_get(props, "data.content.field_table_labels[2]", "")}</div></th.>
                  <th><div>{_get(props, "data.content.field_table_labels[3]", "")}</div></th>
                  <th><div>{_get(props, "data.content.field_table_labels[4]", "")}</div></th>
                  <th><div>{_get(props, "data.content.field_table_labels[5]", "")}</div></th> */}
                  {/* <th className={styles.dividedHead}>
                    <span className={styles.subHead}>{props, "data.content.field_table_labels[6]", ""}</span>
                    <table className={styles.subDivision}>
                      <thead>
                        <th><div>{_get(props, "data.content.field_table_labels[7]", "")}</div></th>
                        <th><div>{_get(props, "data.content.field_table_labels[8]", "")}</div></th>
                      </thead>
                    </table>
                  </th> */}
                  {/* <th><div>{_get(props, "data.content.field_table_labels[6]", "")}</div></th>
                  <th><div>{_get(props, "data.content.field_table_labels[7]", "")}</div></th>
                  <th><div>{_get(props, "data.content.field_table_labels[8]", "")}</div></th>
                  <th><div>{_get(props, "data.content.field_table_labels[9]", "")}</div></th>
                  <th><div>{_get(props, "data.content.field_table_labels[10]", "")}</div></th>
                  <th><div>{_get(props, "data.content.field_table_labels[11]", "")}</div></th>
                  <th><div>{_get(props, "data.content.field_table_labels[12]", "")}</div></th> */}
                  {/* <th className="fix">Actions</th> */}
                </tr>
              </thead>
              {/* 
              {
                isTabletOrMobile ?

                  <tbody>
                    {props.loading || loading ? (
                      <div className={styles.container}>
                        <div className={`${styles.loader} ${styles.loader3}`}></div>
                      </div>
                    ) : filteredDemandData != null ?

                      filteredDemandData.slice((paginationNum - 1) * 5, paginationNum * 5).map((item, index) => (
                        <tr key={index} id={`tableRow${index}`}>
                          <td><div>{(index + 1 + ((paginationNum - 1) * 5))}</div></td>
                          <td><div>{item.cluster}</div></td>
                          <td><div>{item.area}</div></td>
                          <td><div>{item.director}</div></td>
                          <td><div>{item.spoc}</div></td>
                          <td><div>{item.targetPitch}</div></td>
                          <td className={styles.dividedBody}>
                            <table className={styles.subDivision}>
                              <tbody>
                                <td><div>{item.sessionDate}</div></td>
                                <td><div>{item.sessionLedBy}</div></td>
                              </tbody>
                            </table>
                          </td>
                          <td><div>{item.currentStatus}</div></td>
                          <td><div>{item.convertedDemand}</div></td>
                          <td><div>{item.el}</div></td>
                        </tr>))

                      : null}
                  </tbody>

                  : */}

              {props.loading || loading ? (
                <div className={styles.loadContainer}>
                  <Loader />
                </div>
              ) : (
                <tbody>
                  {filteredDemandData != null
                    ? filteredDemandData.map((item, index) => (
                        <tr key={index} id={`tableDesktopRow${index}`}>
                          <td>
                            <div>
                              {filterOn
                                ? (filterPaginationNum - 1) * 5 + index + 1
                                : botCount - item.rowKey + 1}
                            </div>
                          </td>
                          <td>
                            <div>{item.cluster}</div>
                          </td>
                          <td>
                            <div>{item.subArea}</div>
                          </td>
                          <td>
                            <div>{item.product}</div>
                          </td>
                          <td>
                            <div style={{ width: "200px" }}>
                              {item.mcoLeadPlatform}
                            </div>
                          </td>
                          <td>
                            <div style={{ width: "150px" }}>
                              {item.targetPitch}
                            </div>
                          </td>

                          <td>
                            <div style={{ width: "150px" }}>
                              {item.sessionDate}
                            </div>
                          </td>
                          <td>
                            <div>{item.el}</div>
                          </td>

                          <td>
                            <div style={{ width: "150px" }}>
                              {item.currentStatus}
                            </div>
                          </td>
                          <td>
                            <div style={{ width: "150px" }}>
                              {item.convertedDemand}
                            </div>
                          </td>
                          <td>
                            <div>{item.productOwner}</div>
                          </td>
                          <td>
                            <div style={{ width: "250px" }}>
                              {" "}
                              {item.commentsFromStakeHolder}
                            </div>
                          </td>
                        </tr>
                      ))
                    : null}
                </tbody>
              )}
              {/* } */}
            </table>
          ) : noImage ? (
            <div className={styles.noresults}>
              <img
                src={`${endpoint.drupalIp}${_.get(
                  props.noimageUrl,
                  "field_no_result_image[0].file_url",
                  ""
                )}`}
              />
              <h3 className={styles.head}>
                {" "}
                {_.get(props.noimageUrl, "field_title", "")}
              </h3>
              <div
                className={styles.content}
                dangerouslySetInnerHTML={{
                  __html: _.get(props.noimageUrl, "field_details", ""),
                }}
              ></div>
            </div>
          ) : null}
        </div>
        {/* } */}

        {filteredDemandData.length != 0 ? (
          <div className={styles.fixedTable}>
            {props.loading || loading ? null : (
              <table>
                <thead>
                  <th>
                    {_get(props, "data.content.field_table_labels[12]", "")}
                  </th>
                </thead>

                <tbody>
                  {filteredDemandData != null ? (
                    <>
                      {/* {filteredDemandData.slice((paginationNum - 1) * 5, paginationNum * 5).map((item, index) =>
                    <tr id={`actionMobileRow${index}`} className={styles.actionMobile}>
                      <td onClick={() => editModal(item.rowKey)}>
                        <div>
                          <Icons name="pencilDark" className={styles.editInactive} />
                        </div>
                      </td>
                    </tr>
                  )} */}

                      {filteredDemandData.map((item, index) => (
                        <tr
                          id={`actionDesktopRow${index}`}
                          className={styles.actionDesktop}
                        >
                          <td onClick={() => editModal(item.rowKey)}>
                            <div>
                              <Icons
                                name="pencilDark"
                                className={styles.editInactive}
                              />
                            </div>
                          </td>
                        </tr>
                      ))}
                    </>
                  ) : null}
                </tbody>
              </table>
            )}
          </div>
        ) : null}

        {modalactive ? (
          <EditModal
            demandFormData={demandFormData}
            closeModal={closeModal}
            demandEditData={
              newDemand == true
                ? null
                : filteredDemandData.filter((item) => {
                    if (item.rowKey == editIndex) return item;
                  })[0]
            }
            globalData={props.globalData}
            setLoading = {setLoading}
            setmodalactive = {setmodalactive}
            setState= {setState}
            initialState = {initialState}
            setSearchState={setSearchState}
            setFilterOn={setFilterOn}
            setPaginationNum = {setPaginationNum}

            
            
          />
        ) : null}
      </div>
      <div className={styles.mobileFilterBtn}>
        <span className={styles.btn} onClick={filterClick}>
          <Icons name="filters" className={styles.filterIcon} />
          Filters
          <sup className={styles.filterCount}>{length > 4 ? 4 : length}</sup>
          
        </span>
      </div>
      {filteredDemandData.length != 0 ? (
        <div className={styles.pagination}>
          {filterOn ? (
            <Pagination
              totalLength={filterBotCount}
              paginationNum={filterPaginationNum}
              setPaginationNum={setFilterPaginationNum}
            />
          ) : (
            <Pagination
              totalLength={botCount}
              paginationNum={paginationNum}
              setPaginationNum={setPaginationNum}
            />
          )}
        </div>
      ) : null}

      {filterActive ? (
        <MobileFilters
          filterMobileData={data.field_demand_table_filters}
          setState={setState}
          setFilterActive={setFilterActive}
          previousState={state}
          mobileFilterRelatedInfo={mobileFilterRelatedInfo}
          setMobileFilterRelatedInfo={setMobileFilterRelatedInfo}
          setLength={setLength}
          length={length}
          setFilterOn={setFilterOn}
          initialState={initialState}
        />
      ) : null}
      {successModal ? (
        <SuccessModal
          setSuccessModal={setSuccessModal}
          title={"Edit Demand"}
          message={message}
        />
      ) : null}
    </div>
  );
}

const mapStateToProps = (state) => {
  //console.log("state", state);
  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(index);
